import { render, staticRenderFns } from "./WyseTextarea.vue?vue&type=template&id=58e24ffd&scoped=true&"
import script from "./WyseTextarea.vue?vue&type=script&lang=js&"
export * from "./WyseTextarea.vue?vue&type=script&lang=js&"
import style0 from "./WyseTextarea.vue?vue&type=style&index=0&id=58e24ffd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e24ffd",
  null
  
)

export default component.exports